import { render, staticRenderFns } from "./PortalVista.vue?vue&type=template&id=3d65bfac&scoped=true"
import script from "./PortalVista.vue?vue&type=script&lang=js"
export * from "./PortalVista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d65bfac",
  null
  
)

export default component.exports